/* eslint-disable camelcase */
import axios from 'axios'

export type Prompt = {
  theme: string
  moods: (string | undefined)[]
  genre?: string
  songCount?: number
  description: string
}

export type Song = {
  artist: string
  title: string
}

const formatPrompt = (prompt: Prompt) => {
  const { theme, moods, genre, songCount, description } = prompt
  const string = `Can you give me and array of real song and artist names of ${songCount} songs that match the following format:\n\nTheme: ${theme}\nMoods: ${moods}\nDescription: ${description}\n${
    genre ? `Genre: ${genre}` : ''
  }`

  return string
}

export const fetchSongs = async (prompt: Prompt) => {
  const formattedPrompt = formatPrompt(prompt)

  const response = await axios.post(
    'https://api.openai.com/v1/chat/completions',
    {
      messages: [
        {
          role: 'system',
          content:
            'You are a helpful music supervisor assistant that only speaks JSON. Do not write normal text. Only return arrays using this example: { artist: "artist", title: "title" }',
        },
        {
          role: 'user',
          content: formattedPrompt,
        },
      ],
      model: 'gpt-4',
    },
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_OPENAI_API_KEY}`,
      },
    },
  )

  return response?.data?.choices[0]?.message?.content
    ? JSON.parse(response?.data?.choices[0]?.message?.content)
    : null
}
